import React from "react";
import styled from "styled-components";

const CustomTable = styled.table`
  &&& {
    text-align: left;
    width: 100%;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  }
  th {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    padding: 20px 20px;
  }
  td {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    padding: 10px 20px;
  }
`;

function AirSpeedTable() {
  return (
    <CustomTable>
      <tbody>
        <tr>
          <td>&lt; 40 fpm (0.20 m/s)</td>
          <td>Imperceptible</td>
        </tr>
        <tr>
          <td>85 fpm (0.43 m/s)</td>
          <td>Start of significant cooling effect</td>
        </tr>
        <tr>
          <td>90 fpm (0.46 m/s)</td>
          <td>Average walking speed of a giant Galapagos tortoise</td>
        </tr>
        <tr>
          <td>160 fpm (0.81 m/s)</td>
          <td>Upper limit for no local control per ASHRAE Standard 55</td>
        </tr>
        <tr>
          <td>200 fpm (1.0 m/s)</td>
          <td>
            Suggested maximum targeted air speed - conditioned, sensitive
            environments
          </td>
        </tr>
      </tbody>
    </CustomTable>
  );
}

export default AirSpeedTable;
